module.exports = __webpack_public_path__ + "static/media/td.1f6f1b02.svg";